const React = require('react');
const noop = require('mn-utils/noop');
const {default: Button} = require('@material-ui/core/Button');

module.exports = ({children, formCtx, onClick, disabled, testId}) => {
  const isLoading = formCtx && formCtx.state.loading;

  return (
    <Button
      type="button"
      variant="outlined"
      className={`
        (w268|h60|layoutRow|jcC|aiC|f16|fw4|c5B47FF|bc5B47FF|r0|dn).MuiButton-outlined
        (w250)@m.MuiButton-outlined
        (bgF3F1FF).MuiButton-outlined:h
      `}
      onClick={onClick || noop()}
      disabled={disabled || isLoading}
      data-testid={testId}
    >
      {children}
    </Button>
  )
};
